






































import myFormInterface from "@/types/myFormInterface";

import Vue, { PropType } from "vue";
import { mapActions } from "vuex";
import Document from "@/types/documents/document";
import { DocumentStateService } from "@/services/models/document/documentState";

export default (Vue as myFormInterface).extend({
  props: {
    folder: {
      required: true,
      type: String,
    },
    document: {
      required: true,
      type: Object as PropType<Document>,
    },
  },
  data() {
    return {
      isLoading: false,
      dialog: false,
    };
  },
  methods: {
    ...mapActions({
      getFolderDocuments: "documents/getFolderDocument",
    }),
    async invalidDetail() {
      try {
        this.isLoading = true;
        let documentState = this.document.documents_states?.find(
          (state) => state.user_id == this.getCurrentUserLoggedIn().id
        );
        if (documentState) {
          await DocumentStateService.update(documentState.id, {
            ...documentState,
            folder_id: null,
          });
        }
        this.displayToast({
          type: "success",
          message: "La operación se ha realizado con éxito",
        });
        this.getFolderDocuments({
          user_id: this.getCurrentUserLoggedIn().id,
          folder_id: this.$route.params.id,
        });
      } catch (error) {
        console.log(error);
        this.displayToast({
          type: "error",
          message: "Lo sentimos, ha ocurrido un error al realizar la acción",
        });
      } finally {
        this.isLoading = false;
        this.dialog = false;
      }
    },
  },
  watch: {
    async dialog() {
      if (this.dialog) {
        this.cleanForm(this, "formInvalid");
      }
    },
  },
});
